<template>
    <button>{{ tag }}</button>
</template>

<script>
export default {
    props: ['tag'],
}
</script>

<style lang="scss" scoped>
button {
    cursor: pointer;
    color: var(--color-primary);
    background: var(--color-background);
    outline: none;
    border: none;
    padding: 0.5rem;
    margin: 0.5rem;
    border-radius: 0.5rem;
    transition: all 0.2s;
    &:hover {
        background: var(--color-primary);
        color: white;
    }
}
</style>
